"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const lodash_1 = require("lodash");
/**
 * Blockquote
 * @block
 */
const Blockquote = ({ className, children, title, author, source, classNames = [], }) => (react_1.default.createElement("figure", { className: className || (0, classnames_1.default)('blockquote-container', ...classNames) },
    title && react_1.default.createElement("h2", null, title),
    children && react_1.default.createElement("blockquote", { className: "blockquote" }, children),
    (author || source) && (react_1.default.createElement("figcaption", { className: "blockquote-footer" }, (0, lodash_1.compact)([author, source]).join(', ')))));
exports.default = Blockquote;
